import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Postman from '../../utils/service';
import { cutString, encodeforspace, encodeIndustryName, amountFormatter } from '../../utils/helper';
import { isEmpty } from '../../common/utils'
import LazyLoad from 'react-lazyload';
import Cookies from 'js-cookie';

export class Competitors extends Component {

    constructor(props) {
        super(props)
        this.state = {
            competitorModel: '',
            isLoggedIn: Cookies.get('token') || Cookies.get('accessToken') ? true : false,
        }
    }
    handleChange(e) {
        this.setState({ competitorModel: e.target.value });
    }

    handleClick(url) {
        Postman.addCompetitor({
            url,
            company_name: this.props.company.company_name,
            company_id: this.props.company.id
        }).then(() => {
            this.setState({ competitorModel: '' });
        });
    }
    getQueryStrings(location) {

        var assoc = {};
        var decode = function (s) { return decodeURIComponent(s.replace(/\+/g, " ")); };
        var queryString = location.search.substring(1);
        var keyValues = queryString.split('&');

        for (var i in keyValues) {
            var key = keyValues[i].split('=');
            if (key.length > 1) {
                assoc[decode(key[0])] = decode(key[1]);
            }
        }

        return assoc;
    }
    order(name) {
        const query = this.getQueryStrings(this.props.location.location);
        let orderby = query.orderby || 'asc';
        if (name == query.order) {
            orderby = orderby == 'asc' ? 'desc' : 'asc';
        }
        return `order=${name}&orderby=${orderby}`
    }

    OrderArrow = ({ name }) => {

        const query = this.getQueryStrings(this.props.location.location);
        let orderby = query.orderby || 'asc';
        if (name == query.order) {
            orderby = orderby == 'asc' ? 'desc' : 'asc';
        }
        let dir = orderby == 'asc' ? 'up' : 'down';
        if (orderby === 'asc') {
            return (
                <i style={
                    {
                        fontFamily: "fontawesome",
                        fontStyle: "normal"
                    }
                } class="fas fa-sort-down"></i>
            );
        } else {
            return (<i
                style={
                    {
                        fontFamily: "fontawesome",
                        fontStyle: "normal"
                    }
                }
                class="fas fa-sort-up"></i>);
        }

    }

    exportcompetitors = () => {
        if (!this.state.isLoggedIn) {
            this.props.history.push(`/join`);
        } else {
            Postman.getCompetitorsCsv(this.props.company.id)
            .then(res => {
              const url = window.URL.createObjectURL(new Blob([res.data]));
              const link = document.createElement('a');
              link.href = url;
              link.setAttribute('download', this.props.company.company_name+'_competitors.csv');
              document.body.appendChild(link);
              link.click();
            })
            .catch(e => {
              console.log('e', e)
              // this.props.history.push('/join')
            });
        }
    }

    render() {
        const { data, industry } = this.props;



        if (isEmpty(data)) {
            return null;
        }


        return (<React.Fragment>


            <div className="ads-wrapper">
                <h2 id="competitors" className="google-ads">{this.props.company.company_name} Competitors & Alternatives
                <Link to={'/add-your-company'} style={{textDecoration: "underline "}} className={"font-lg font-weight-bold p-lg-4"} >Add Company</Link></h2>
                
                <div onClick={this.exportcompetitors} style={{cursor: 'pointer'}}>
                    <LazyLoad>
                        <img src={`/static/img/export.png`} width='48px' />
                    </LazyLoad>
                </div>
            </div>
            <table className="table table-bordered cstm-table">
                <thead>
                    <tr style={{ backgroundColor: 'rgb(71, 72, 102)', color: 'white' }}>
                        <th scope="col">
                            Competitor Name

                        </th>
                        <th scope="col">
                            Revenue
                        </th>
                        <th scope="col">
                            Number of Employees
                            
                        </th>
                        <th scope="col">
                            Employee Growth
                            
                        </th>
                        <th scope="col">
                            Total Funding
                            
                        </th>
                        <th scope="col">
                            Valuation
                        </th>
                       
                    </tr>
                </thead>
                <tbody>
                    {data.map((company, index) => {
                        const { company_name, estimated_revenues, current_employees, last_employees, total_funding, url, linkedin_url, pricing, rating, valuation } = company;
                        const funding = total_funding ? total_funding : 'N/A';
                        const total_pricing = pricing ? pricing : 'N/A';
                        const _estimated_revenues = estimated_revenues ? `$${Math.round(estimated_revenues / 100000) / 10}M` : 'N/A';
                        const growth = current_employees && last_employees ? Math.round((current_employees - last_employees) / last_employees * 100) + '%' : 'N/A';
                        const competitorAd = company.sort < 100 && company.competitor_ad_text != '' && company.competitor_ad_link != '' ?
                            (
                                <div style={{ display: 'inline-block', marginLeft: 20 }}>
                                    <a href={company.competitor_ad_link} className="btn btn-primary btn-sm" target="blank" >
                                        {company.competitor_ad_text}
                                    </a>
                                </div>
                            ) : false
                        return (
                            <tr key={index + 'similar'}>
                                <td>
                                    <div style={{ display: 'inline-block' }}>
                                        #{index + 1}
                                    </div>
                                    <div style={{ display: 'inline-block', marginLeft: 8 }}>
                                        <a href={`//${url}`} target="_blank" onClick={(e) => { e.stopPropagation(); }} style={{ marginRight: 5, fontSize: 15, color: '#13135c', textDecoration: "none" }}>
                                            <LazyLoad>
                                                <img src={`https://www.google.com/s2/favicons?domain=${url}`} style={{ marginRight: 5, width: 18 }} />
                                            </LazyLoad>
                                        </a>
                                        <Link to={`/company/${encodeforspace(company_name)}`} style={{ marginRight: 5, fontSize: 15, textDecoration: 'none' }}>{cutString(company_name, 15)}</Link>
                                    </div>


                                    {/* <div style={{ display: 'inline-block', marginLeft: 8 }}>
                                            <a href={linkedin_url} target="_blank" onClick={(e) => { e.stopPropagation(); }}>
                                                <LazyLoad>
                                                    <LinkedinIcon size={15} />
                                                </LazyLoad>
                                            </a>


                                        </div> */}
                                    {competitorAd}
                                </td>
                                <td>{_estimated_revenues}</td>
                                <td>{current_employees}</td>
                                <td>{growth}</td>
                                <td>{funding}</td>
                                <td>{valuation > 1 ? '$' + amountFormatter(valuation, 1) : 'N/A'}</td>
                                {/* <td>{!rating ? '-' : rating + '/5'}</td> */}
                                {/* <td>{total_pricing}</td> */}
                            </tr>);
                    })}
                </tbody>
            </table>
            <Link to={'/add-your-company'} style={{textDecoration: "underline "}} className={"font-lg font-weight-bold p-lg-4"} >Add Company</Link>
            <div style={{ width: '100%', textAlign: 'center' }}>
                <div className='showmoreBtn'>
                    <Link to={`/industry/${encodeURIComponent(encodeIndustryName(industry))}`}>Show More {industry} Companies</Link>
                </div>
            </div>
           
        </React.Fragment>);
    }
}


// WEBPACK FOOTER //
// ./client/src/views/CompanyDetail/Competitors.js